import React, { memo, useEffect, useRef } from "react";
import { getClass, parseQs, setDangerousHtml, useDebounce } from "../../../utils";
import styles from "../../Search/ResultsSERP/style.css";
import { useStore } from "../../../store";
import Pagination from "../../Pagination";
import YahooAd from "./YahooAd";

function initializeClarity(store, data) {
  let clarityId;
  let testTraffic;
  const children = store("children");

  // Initialize clarity and related scripts if present in config
  if (children && children.length > 0) {
    children.forEach(item => {
      if (item.name === "customComponentV2") {
        const { yahooClarityProjectId, yahooClarityScriptTestTraffic } = item.props.componentConfig;

        clarityId = yahooClarityProjectId;
        testTraffic = yahooClarityScriptTestTraffic;

        window.ysapiIns =
          window.ysapiIns ||
          function() {
            (window.ysapiIns.q = window.ysapiIns.q || []).push(arguments);
          };
        window.ysapiIns.l = 1 * new Date();

        if (!document.querySelector(`script[src="https://s.yimg.com/ds/scripts/ysapiIns-v1.1.0.js"]`)) {
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.async = true;
          script.defer = true;
          script.src = "https://s.yimg.com/ds/scripts/ysapiIns-v1.1.0.js";
          document.getElementsByTagName("head")[0].appendChild(script);
        }

        window.ysapiIns("init", {
          tm_cl: {
            enableCookie: true,
            enableClarity: true,
            enableTrackSignals: true
          },
          source_tag: data.partnerTag,
          ysid: data.providerSearchId,
          cid: data.providerClientId,
          ig: data.providerImpressionGuId,
          select_tier: {
            clarityId: clarityId,
            rguid: data.providerRguId
          },
          test_mode: testTraffic === "true"
        });
      }
    });
  }

  return { clarityId, testTraffic };
}

const YahooAdsV2 = memo(
  ({
    translator,
    data,
    loading,
    searchParams,
    sponsoredSearchResults2Style,
    dublicateResults,
    country,
    clickNotify,
    sponsoredSearchResults2ClientImpressionsURL,
    sendClientEvents,
    reqId,
    URL,
    adsAPI,
    otherParams,
    overrideOrganicStyles,
    paginationParams,
    articlePage,
    ...props
  }) => {
    const store = useStore(["children", "loadedAds"]);
    const intervalRef = useRef(null);
    const { isSponsoredOnly, paginationEnabled } = paginationParams;
    const { query, history, match } = store("search");
    const organicAds = data && data.organic ? data.organic : data && data.content && data.content.length > 0 ? data.content[0].value.items : [];
    const { titleColor, titleFontSize, siteColor, siteFontSize, descriptionColor, descriptionFontSize } = overrideOrganicStyles;
    const beaconUrl = `https://search.yahoo.com/beacon/geop/p?s=1197812282&ysid=${data?.providerSearchId}&traffic_source=${data?.partnerTag}`;

    const setSearch = params => {
      store.set("search", {
        ...store("search"),
        ...params
      });
    };

    useEffect(() => {
      if (data && data?.consentCookies) {
        store.set("config.gdpr", {
          style: "bottom",
          maxNotifications: 2,
          message: "By continuing to use this website you agree to the terms outlined in the Privacy Policy and Cookie Policy"
        });
      }
    }, [data?.consentCookies]);

    const submitSearch = useDebounce(
      (val, override) => {
        const v = !val && val !== "" ? query : val;
        setSearch({ query: v, p: override?.page });
        const { page, variant, provider } = parseQs(window.location.search);
        const pageInUrl = override?.page ? `&p=${override.page}` : "";
        history.push({
          pathname: match.pathname,
          search: `?q=${v}${page ? "&page=" + page : ""}${variant ? "&variant=" + variant : ""}${provider ? "&provider=" + provider : ""}${pageInUrl}`
        });
        adsAPI.call({
          ...searchParams,
          ...override,
          p: override.page,
          searchTerm: v,
          datetime: new Date().toISOString(),
          userLocalDatetime: new Date().toISOString()
        });
      },
      500,
      [adsAPI?.loading]
    );

    useEffect(() => {
      const { clarityId, testTraffic } = initializeClarity(store, data);

      intervalRef.current = setInterval(() => {
        if (window.clarity && window.clarity.v && window.selectTier) {
          window.selectTier.init({
            source_tag: data.partnerTag,
            ysid: data.providerSearchId,
            cid: data.providerClientId,
            ig: data.providerImpressionGuId,
            select_tier: {
              clarityId: clarityId,
              rguid: data.providerRguId
            },
            test_mode: testTraffic === "true"
          });
          clearInterval(intervalRef.current);
        }
      }, 300);

      return () => clearInterval(intervalRef.current);
    }, [data]);

    return (
      <div>
        <section id="sponsoredCtrlId">
          <img height="1" width="1" src={beaconUrl} alt="" hidden />
          {data.ads &&
            data.ads.map((item, index) => {
              const paramsForYahooAd = {
                item,
                index,
                data,
                clickNotify,
                loading,
                extraParams: {
                  clientId: searchParams.clientId,
                  searchTerm: searchParams.searchTerm,
                  serpLayoutVariant: searchParams.serpLayoutVariant,
                  brand: searchParams.brand,
                  dublicateResults
                },
                sponsoredSearchResults2ClientImpressionsURL,
                sendClientEvents,
                URL,
                country,
                sponsoredSearchResults2Style,
                reqId,
                articlePage
              };

              return (
                <div key={index}>
                  <YahooAd {...paramsForYahooAd} />
                </div>
              );
            })}
        </section>

        {organicAds && organicAds.length > 0 && (
          <section id="organicCtrlId" className={styles.organicYahooContainer}>
            <header className={styles.organicYahooHeader}>{translator("Search.Web Results")}</header>
            {organicAds.map((organicAd, key) => (
              <article
                key={key}
                className={getClass(styles.genericItem, styles.organicYahooArticle)}
                data-af-component={props["data-af-component"] || ""}
              >
                <div>
                  <a
                    ref={setDangerousHtml(organicAd.title)}
                    style={{
                      color: titleColor || "",
                      fontSize: titleFontSize || ""
                    }}
                    href={organicAd.clickUrl}
                    onClick={clickNotify(props, otherParams)}
                  />
                  <span
                    ref={setDangerousHtml(organicAd.domain)}
                    style={{
                      color: siteColor || "",
                      fontSize: siteFontSize || ""
                    }}
                  />
                  <div
                    ref={setDangerousHtml(organicAd.description)}
                    style={{
                      color: descriptionColor || "",
                      fontSize: descriptionFontSize || ""
                    }}
                  />
                </div>
              </article>
            ))}
          </section>
        )}

        {paginationEnabled && isSponsoredOnly ? <Pagination submitSearch={p => submitSearch(false, { page: p })} /> : null}
      </div>
    );
  }
);

export default YahooAdsV2;
